import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  whiteSpace: 'nowrap',
};
